import useAsyncMemo from '@onepercentio/one-ui/hooks/utility/useAsyncMemo'
import { storage } from 'core/modules/firebase'

const pathCache: { [path: string]: string } = {}
export default function useStorageIcon(possiblePath: string | undefined) {
  const [img] = useAsyncMemo(async () => {
    if (pathCache[possiblePath!]) return pathCache[possiblePath!]
    const parseAssetWeirdPattern = () => {
      /** It has starting bucket name */
      const withoutBucketName = possiblePath!.split('/').slice(1).join('/')
      /** It also has a .png-weird-stuff */
      return `${withoutBucketName.split('png')[0]}png`
    }
    const targetPath = possiblePath?.includes('appspot')
      ? parseAssetWeirdPattern()
      : possiblePath
    if (targetPath)
      try {
        const isUrl = targetPath.startsWith('http') || targetPath.startsWith('gs') || targetPath.includes('firebasestorage')
        const ref = isUrl ? storage.refFromURL(targetPath) : storage.ref(targetPath)

        return (pathCache[possiblePath!] = await ref.getDownloadURL())
      } catch (e) {
        console.log('had problem', e)

        return possiblePath
      }
  }, [possiblePath])
  return pathCache[possiblePath!] || img || possiblePath
}
